import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { navLinks, siteInfo } from "@/mocks/site";

export default function Header() {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const solid = scrolled || !isHome;
  const tone = solid ? "text-foreground-950" : "text-background-50";

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/95 border-b border-background-200 backdrop-blur"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:h-20 md:px-6">
        <Link to="/" className="group flex items-center gap-3 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-black leading-none text-background-50 md:h-10 md:w-10 md:text-xl">
            18
          </span>
          <span className="flex flex-col leading-none">
            <span className={`font-heading text-lg font-black tracking-tight md:text-xl ${tone}`}>
              {siteInfo.name}
            </span>
            <span
              className={`mt-0.5 text-[11px] tracking-[0.2em] ${
                solid ? "text-foreground-500" : "text-background-200"
              }`}
            >
              ENTERTAINMENT WATCH
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                `rounded-md px-4 py-2 text-sm transition-colors cursor-pointer ${
                  isActive
                    ? solid
                      ? "bg-primary-100 text-primary-700 font-medium"
                      : "bg-background-50/20 text-background-50 font-medium"
                    : solid
                      ? "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                      : "text-background-100 hover:text-background-50"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <Link
            to="/about"
            className="ml-3 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            订阅吃瓜日报
          </Link>
        </nav>

        <button
          type="button"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-md text-2xl md:hidden ${
            solid ? "text-foreground-900" : "text-background-50"
          }`}
        >
          <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav className="flex flex-col px-4 py-3">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-sm ${
                    isActive
                      ? "bg-primary-100 font-medium text-primary-700"
                      : "text-foreground-700"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <Link
              to="/about"
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-3 py-3 text-center text-sm font-medium text-background-50"
            >
              订阅吃瓜日报
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}